module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/legalCertificate/legalCertificate-create/legalCertificate-create.component.scss
// module id = ./src/app/views/legalCertificate/legalCertificate-create/legalCertificate-create.component.scss
// module chunks = main